(() => {
  'use strict';
  const KEY = 'tidilo:wishlist:v1';
  const page = document.querySelector('[data-wishlist-page]');
  const status = page && page.querySelector('[data-wishlist-status]');
  let storageWorks = true;
  function read() {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || '{"version":1,"items":[]}');
      if (!raw || raw.version !== 1 || !Array.isArray(raw.items)) return [];
      const seen = new Set();
      return raw.items.filter(item => {
        if (!item || !/^\d+$/.test(String(item.productId)) || !(item.variantId === '' || /^\d+$/.test(String(item.variantId))) || !/^[a-z0-9-]+$/.test(String(item.handle))) return false;
        const itemKey = key(item);
        if (seen.has(itemKey)) return false;
        seen.add(itemKey); return true;
      }).slice(0, 100);
    } catch (_) { storageWorks = false; return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify({version:1,items})); storageWorks = true; return true; }
    catch (_) { storageWorks = false; if (status) status.textContent = 'Saved items cannot be stored in this browser. Check your browser storage settings.'; return false; }
  }
  function key(item) { return item.variantId === '' ? String(item.productId) : `${item.productId}:${item.variantId}`; }
  function sync() {
    const saved = new Set(read().map(key));
    document.querySelectorAll('.wishlist-heart').forEach(button => {
      const active = saved.has(key({productId:button.dataset.wishlistProduct,variantId:button.dataset.wishlistVariant || ''})) || saved.has(String(button.dataset.wishlistProduct));
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Save'} ${button.dataset.wishlistTitle} ${active ? 'from' : 'to'} saved items`);
      if (button.classList.contains('wishlist-heart--product')) { button.disabled = false; button.title = ''; }
    });
  }
  function el(tag, className, text) { const node = document.createElement(tag); if (className) node.className = className; if (text != null) node.textContent = text; return node; }
  function money(cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:currency || 'USD'}).format(Number(cents)/100); }
    catch (_) { return ''; }
  }
  async function render() {
    if (!page) return;
    const list = page.querySelector('[data-wishlist-list]'), empty = page.querySelector('[data-wishlist-empty]');
    const items = read(); list.replaceChildren(); empty.hidden = items.length > 0;
    if (!items.length) { status.textContent = storageWorks ? '' : 'Saved items cannot be read in this browser.'; return; }
    status.textContent = 'Loading current product details…';
    const grid = el('div','wishlist-page__grid'); list.append(grid);
    const cards = items.map(() => el('article','wishlist-item')); cards.forEach(card => grid.append(card));
    await Promise.all(items.map(async (item, index) => {
      const card = cards[index];
      let product = null;
      try { const response = await fetch(`/products/${encodeURIComponent(item.handle)}.js`, {credentials:'same-origin'}); if (response.ok) product = await response.json(); } catch (_) {}
      const variant = product && String(product.id) === String(item.productId) && (item.variantId === '' ? product.variants.find(v => v.available) || product.variants[0] : product.variants.find(v => String(v.id) === String(item.variantId)));
      if (variant) {
        const a = el('a'); a.href = `/products/${encodeURIComponent(item.handle)}${item.variantId === '' ? '' : '?variant=' + encodeURIComponent(item.variantId)}`;
        const image = variant.featured_image && variant.featured_image.src || product.featured_image;
        if (image) { const img = el('img'); img.src = image; img.alt = product.title; img.loading = 'lazy'; a.append(img); }
        a.append(el('h2','',product.title)); card.append(a);
        if (item.variantId === '') card.append(el('p','','Choose size at cart'));
        else if (variant.title && variant.title !== 'Default Title') card.append(el('p','',variant.title));
        card.append(el('p','',money(variant.price, product.currency)));
        if (!variant.available) card.append(el('p','','Sold out — this option is currently unavailable.'));
      } else { card.classList.add('wishlist-item--unavailable'); card.append(el('h2','','Item unavailable'),el('p','','This product or option is no longer available.')); }
      const remove = el('button','wishlist-remove','Remove'); remove.type = 'button'; remove.dataset.wishlistRemove = key(item); remove.setAttribute('aria-label',`Remove ${variant ? product.title : 'unavailable item'} from saved items`); card.append(remove);
    }));
    status.textContent = '';
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('.wishlist-heart');
    if (button && !button.disabled) {
      event.preventDefault(); event.stopPropagation();
      const item = {productId:button.dataset.wishlistProduct,variantId:button.dataset.wishlistVariant || '',handle:button.dataset.wishlistHandle};
      const items = read(), index = items.findIndex(saved => key(saved) === key(item));
      if (index >= 0) items.splice(index,1);
      else { const sizeless = items.findIndex(saved => String(saved.productId) === String(item.productId) && saved.variantId === ''); if (sizeless >= 0) items[sizeless] = item; else items.push(item); }
      if (write(items)) { sync(); render(); }
      return;
    }
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) { const items = read().filter(item => key(item) !== remove.dataset.wishlistRemove); if (write(items)) { sync(); render(); } }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('.pdp select[name="id"]')) {
      const button = document.querySelector('.wishlist-heart--product'); if (!button) return;
      button.dataset.wishlistVariant = event.target.value;
      button.disabled = false;
      if (event.target.value) {
        const items = read(), index = items.findIndex(item => String(item.productId) === String(button.dataset.wishlistProduct) && item.variantId === '');
        if (index >= 0) {
          const upgraded = {...items[index], variantId:event.target.value};
          items[index] = upgraded;
          write(items.filter((item, i) => i === index || key(item) !== key(upgraded)));
        }
      }
      sync();
    }
  });
  window.addEventListener('storage', event => { if (event.key === KEY) { sync(); render(); } });
  sync(); render();
})();